import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { Formik, Form, Field, FieldArray } from "formik";
import FormModal from "../../FormModal";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import {
  OutlineTextField,
  OutlineSelect,
  OutlineSearchable,
} from "../../FormikCustoms";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";

function ModalData({
  open,
  handleClose,
  handleSave,
  loadingTypes,
  products,
  editedData,
}) {
  const [feedback, setFeedback] = useState({});

  const handleOnFeedback = () => {
    if (feedback.success) {
      handleOnclose();
    } else {
      setFeedback({});
    }
  };

  const handleOnclose = () => {
    handleClose();
    setFeedback({});
  };

  const handleValidates = (values) => {
    const errors = {};
    if (!values.description) {
      errors.description = "Informe o nome da doca.";
    }else if(values.description.length > 50){
      errors.description = "Nome da doca não deve exceder o máximo de 50 caracteres.";
      errors.error = true
    }else if(values.description.length < 3){
      errors.description = "Nome da doca deve possuir no mínimo 3 caracteres.";
      errors.error = true
    }

    if (!values.capacity_per_hour) {
      errors.capacity_per_hour = "Informe a capacidade.";
    }
    for (let i = 0; i < values.dockTypes.length; i++) {
      const dockType = values.dockTypes[i];
      const dockError = {};

      if (!dockType.id_product) {
        dockError.id_product = "Informe o tipo de produto.";
      }
      if (!dockType.id_load_type) {
        dockError.id_load_type = "Informe o tipo de operação.";
      }

      if (Object.keys(dockError).length > 0) {
        if (!errors.dockTypes) {
          errors.dockTypes = [];
        }
        errors.dockTypes[i] = dockError;
      }
    }
    return errors;
  };

  const handleSubmit = async (values, setSubmitting) => {
    const operationFeedback = await handleSave(values);
    setSubmitting(false);
    setFeedback(operationFeedback);
    return;
  };

  return (
    <FormModal
      title={editedData.id ? "Editar doca" : "Adicionar doca"}
      open={open}
      handleClose={handleOnclose}
    >
      {!Object.keys(feedback).length ? (
        <Formik
          initialValues={{
            id: editedData.id ?? null,
            dockTypes:
              editedData.dockTypes && editedData.dockTypes.length
                ? editedData.dockTypes
                : [{ id_product: "", id_load_type: "" }],
            description: editedData.description ?? "",
            capacity_per_hour: editedData.capacity_per_hour ?? 1,
          }}
          validate={(values) => handleValidates(values)}
          onSubmit={async (values, { setSubmitting }) =>
            handleSubmit(values, setSubmitting)
          }
        >
          {({ submitForm, setFieldValue, isSubmitting, errors, values }) => (
            <Form
               data-cy="dock-form"
               id="dock-form"
            >
              <Grid container spacing={3}>
                <Grid item md={8} xs={12}>
                  <Field
                    component={OutlineTextField}
                    name="description"
                    data-cy="dock-name"
                    id="dock-name"
                    type="text"
                    label="Nome da doca *"
                    value={values.description && values.description}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <Field
                    component={OutlineTextField}
                    name="capacity_per_hour"
                    type="number"
                    data-cy="dock-capacity"
                    id="dock-capacity"
                    label="Capacidade (Caminhões/Hora)*"
                    value={values.capacity_per_hour && String(values.capacity_per_hour)}
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <FieldArray
                    name="dockTypes"
                    data-cy="dock-types"
                    id="dock-types"
                    render={(arrayHelpers) => (
                      <>
                        {values.dockTypes.map((_, _index) => {
                          const index = _index;
                          const setLabel = (dataArray) => {
                            return dataArray.filter(
                              (i) =>
                                i.id === values.dockTypes[_index].id_product
                            )[0].name;
                          };
                          return (
                            <Grid container key={index} spacing={3}>
                              <Grid item md={4} xs={12}>
                                <Field
                                  component={OutlineSearchable}
                                  name={`dockTypes[${index}].id_product`}
                                  placeholder="Produto que carrega *"
                                  label="Produto que carrega *"
                                  data-cy="dock-type"
                                  id="dock-type"
                                  as="select"
                                  isMulti={false}
                                  value={
                                    values.dockTypes[index].id_product && {
                                      label: setLabel(products),
                                      value: values.dockTypes[index].id_product,
                                    }
                                  }
                                  options={products}
                                  onChange={(selectedOption) => {
                                    setFieldValue(
                                      `dockTypes[${index}].id_product`,
                                      selectedOption.value
                                    );
                                  }}
                                />
                              </Grid>
                              <Grid item md={4} xs={12}>
                                <Field
                                  component={OutlineSelect}
                                  name={`dockTypes.${index}.id_load_type`}
                                  data-cy="dock-operation-type"
                                  id="dock-operation-type"
                                  label="Tipo de operação *"
                                >
                                  {loadingTypes.map((type) => (
                                    <MenuItem key={type.id} value={type.id}>
                                      {type.description}
                                    </MenuItem>
                                  ))}
                                </Field>
                              </Grid>
                              <Grid item md={4} xs={12}>
                                <div
                                  style={{ display: "flex", height: "100%" }}
                                >
                                  {index !== 0 ? (
                                    <IconButton
                                      data-cy="dock-delete-button"
                                      id="dock-delete-button"
                                      onClick={() => arrayHelpers.remove(index)}
                                    >
                                      <DeleteIcon color="error" />
                                    </IconButton>
                                  ) : (
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      data-cy="dock-add"
                                      id="dock-add"
                                      onClick={() =>
                                        arrayHelpers.push({
                                          id_product: "",
                                          id_load_type: "",
                                        })
                                      }
                                      style={{ minWidth: "100%", height: 56 }}
                                      size="large"
                                    >
                                      Adicionar +
                                    </Button>
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                          );
                        })}
                      </>
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <div
                    style={{
                      display: "flex",
                      height: 56,
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      data-cy="dock-save-button"
                      id="dock-save-button"
                      style={{ minWidth: "50%" }}
                      disabled={isSubmitting}
                      onClick={submitForm}
                      size="large"
                    >
                      {isSubmitting ? "Aguarde" : "Salvar"}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      ) : (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h5">{feedback.message}</Typography>
          </Grid>
          <Grid item xs={12}>
            <div
              style={{
                display: "flex",
                height: 56,
                justifyContent: "flex-end",
              }}
            >
              <Button
                onClick={handleOnFeedback}
                variant="contained"
                data-cy="dock-feedback-button"
                color="primary"
                style={{ minWidth: "50%" }}
                size="large"
              >
                {feedback.success ? "Voltar" : "Tentar novamente"}
              </Button>
            </div>
          </Grid>
        </Grid>
      )}
    </FormModal>
  );
}

ModalData.defaultProps = {
  editedData: {},
};

ModalData.propTypes = {
  products: PropTypes.array.isRequired,
  loadingTypes: PropTypes.array.isRequired,
  editedData: PropTypes.object,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
};

export default ModalData;
